<template>
  <v-container row justify-center>
    <v-dialog v-model="dialogWizard" persistent max-width="900px">
      <v-row justify="center" no-gutters>
        <v-col>
          <v-card min-height="600px">
            <div class="title-toolbar">
              <v-btn id="signing_wizard__cerrar_ventana__button" class="mr-3 mt-2 mb-2" icon @click="closeMe">
                <v-icon small>{{ icon.close }}</v-icon>
              </v-btn>
            </div>

            <v-row no-gutters>
              <v-col cols="12">
                <notification-container
                    class="mr-5 ml-5"
                    :showOnlyLocalNotifications="true"
                ></notification-container>
              </v-col>
            </v-row>

            <!-- Stepper -->
            <v-stepper v-model="currentStep">
              <v-stepper-header>
                <template v-for="step in steps">
                  <v-stepper-step
                      :id="`signing_wizard__paso`+step.id+`__stepper`"
                      :color="appThemeComponentsMainColor"
                      :complete="currentStep > step.id"
                      :step="step.id"
                      :key="step.title"
                  >{{ step.title }}</v-stepper-step
                  >
                  <v-divider :key="step.id"></v-divider>
                </template>
              </v-stepper-header>

              <v-progress-linear
                  :indeterminate="this.isBusy"
                  value="100"
                  :color="appThemeComponentsMainColor"
              ></v-progress-linear>

              <v-stepper-items>
                <v-stepper-content
                    v-for="step in steps"
                    :step="step.id"
                    :key="step.id"
                >
                  <component
                      class="component-card"
                      :is="step.component"
                  ></component>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  v-if="currentStep > 1"
                  id="signing_wizard__atras__button"
                  color="success"
                  class="mr-2"
                  @click="this.goBack"
                  :disabled="this.isBusy"
              >Atrás</v-btn
              >
              <v-btn
                  :color="colorButton"
                  id="signing_wizard__siguiente__button"
                  class="mr-5"
                  @click="processStep"
                  :disabled="!this.canGoNext || this.isBusy"
                  :dark="currentStep === this.wizardLength && !this.isBusy"
              >{{ textoButton }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <v-dialog v-model="dialogFinish" persistent max-width="390">
        <v-card id="signing_wizard__firma_exitosa__card">
          <v-card-title class="headline">Firma Exitosa</v-card-title>
          <v-card-text
          >La firma de este documento se ha realizado
            exitosamente.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn id="signing_wizard__aceptar__button" color="green darken-1" text @click="closeMe">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  panelData,
  panelActions,
  pushNotification,
  appThemeData
} from '@/store/helpers'

import {
  signingWizardData,
  signingWizardActions
} from '@/modules/signers/store/signingWizardStoreHelpers'

import {
  viewerPDFData,
  viewerPDFActions
} from '@/modules/signers/store/viewerPDFStoreHelpers'

import { signingReviewActions } from '@/modules/signers/store/signingReviewStoreHelpers'

import {
  fielStorageData,
  fielStorageActions
} from '@/modules/signers/store/fielStorageHelpers'

import ViewerPDF from '@/modules/signers/components/ViewerPDF'
import FielValidatorInline from '@/modules/signers/components/FielValidatorInline'
import SigningReview from '@/modules/signers/components/SigningReview'
import { mdiClose } from '@mdi/js'
import EmailServices from '../../documents/services/EmailService'
import { documentsActions } from '@/modules/documents/store/documentsHelpers'

export default {
  name: 'SigningWizard',
  components: {
    ViewerPDF,
    FielValidatorInline,
    SigningReview
  },
  data() {
    return {
      icon: {
        close: mdiClose
      },
      colorButton: 'success',
      textoButton: 'Siguiente'
    }
  },
  created() {
    this.setOnSuccessFiel(this.goNext)
  },
  computed: {
    ...panelData,
    ...appThemeData,
    ...viewerPDFData,
    ...fielStorageData,
    ...signingWizardData,
    currentStep: {
      get() {
        this.setStepAppereance(this.wizardStep)
        return this.wizardStep
      }
    }
  },
  watch: {
    dialogWizard: function(value) {
      if (value && this.wizardStep === 1 && !this.okPDF) {
        this.getDocumentPDF()
      }
    }
  },
  methods: {
    ...panelActions,
    ...viewerPDFActions,
    ...fielStorageActions,
    ...signingWizardActions,
    ...signingReviewActions,
    ...documentsActions,
    setStepAppereance(step) {
      this.textoButton = 'Siguiente'
      this.colorButton = 'success'
      if (step === this.wizardLength) {
        this.textoButton = 'Firmar'
        this.colorButton = 'blue darken-3'

        this.setDataReview({
          razonSocial: this.fiel != null ? this.fiel.metadata.razonSocial : '',
          rfc: this.fiel != null ? this.fiel.metadata.rfc : ''
        })
      }
    },
    processStep() {
      if (this.wizardStep === this.wizardLength) {
        this.raiseFirmarDocumento()
      } else {
        this.goNext()
      }
    },
    getDocumentPDF() {
      if (this.tokenWizard != null) {
        this.downloadDocumentPdfByToken(this.tokenWizard)
      } else if (this.documentWizard != null) {
        this.downloadDocumentPdf(this.documentWizard)
      }
      this.getMetadata()
    },
    getMetadata() {
      this.getDocumentMetadata()
          .then(result => {
            let resp = result.data.data
            this.setDataReview({
              fileName: resp.nombre || '',
              fileSize:
                  resp.tamanio != undefined
                      ? `${Number.parseFloat(resp.tamanio / 1024 / 1024).toFixed(
                          2
                      )} MB`
                      : '',
              hash: resp.hash || ''
            })
          })
          .catch(() => {
            this.setDataReview({
              fileName: '',
              fileSize: '',
              hash: ''
            })
          })
    },
    raiseFirmarDocumento() {
      this.panelBusy()
      this.signDocument({ fiel: this.fiel, file: this.urlPDF })
        .then(result => {
          this.signDocumentInStorage({
            documentId: result.data.data.idDocumento, 
            status: result.data.data.status, 
            signerId: result.data.data.idFirmante
          })
          this.sendEmail(result.data.data.idDocumento)
        })
        .catch(err => {
          pushNotification(
            this.$store,
            err.response.data.error.message ||
            `El documento no pudo ser firmado.`,
            'error',
            'left',
            false,
            true
          )
          this.panelUnnocupied()
        })
    },
    closeMe() {
      if (this.tokenWizard != null) {
        this.$router.push('/dashboard')
      }
      if (
          this.dialogFinish &&
          this.onSuccessSigning != null &&
          this.onSuccessSigning instanceof Function
      ) {
        this.onSuccessSigning()
      }
      this.closeWizard()
      this.cleanObjectPDF()
      this.resetFiel()
    },
    sendEmail(idDocumento){
      this.panelBusy()
      const emialService = new EmailServices()
      emialService.sendEmailService(this.tokenWizard, {idDocumento: idDocumento})
        .then(() => {
          this.finishWizard()
          this.$emit('signinSuccess', true)
        }).catch(error => {
          pushNotification(
            this.$store,
            error.response.data.error.message ||
            `Se presentó un error al enviar el correo electrónico.`,
            'error',
            'left',
            false,
            true
          )
        })
        .finally(() => {
          this.panelUnnocupied()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.title-toolbar {
  display: grid;
  justify-items: end;
}

.component-card {
  height: 400px;
}
</style>
